import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Actions as PAYROLL_ACTIONS } from "../../../store/actions/payrollActions";
import { ExclamationTriangleIcon, PencilSquareIcon } from "@/icons/solid";
import PayrollReviewReport from "./PayrollReviewReport";

const PayrollClientIssues = ({
	company,
	updatePayPeriodStatus,
	concludePayroll,
	period,
	userIsAdvisor,
	handleConclude,
}) => {
	const { clientReview } = period || {};
	const { madeBy, payslips, note } = clientReview || {};

	return (
		<>
			<div
				className="block text-center bg-white"
				style={{ paddingTop: 80 }}
			>
				<div className="main">
					<h1 className="font-w700 text-center">{company?.name} has not approved this payroll</h1>

					{!!payslips?.length && (
						<div style={{ marginTop: 20 }}>
							<h4 className="text-center">
								{madeBy.name} has highlighted the following payslips which have issues{" "}
							</h4>
							<div
								className="row d-flex justify-content-center"
								style={{ marginTop: 20 }}
							>
								<div
									className="col-auto"
									style={{ width: "100%", margin: "auto" }}
								>
									<PayrollReviewReport withIssues={payslips} />
								</div>
							</div>
						</div>
					)}

					{note && (
						<>
							<h4 className="text-center">{madeBy.name} has left the following comments</h4>
							<div
								className="col-auto"
								style={{ width: "100%", margin: "auto", marginTop: 10 }}
							>
								<textarea
									className="form-control form-input"
									type="text"
									name="comment"
									style={{ minHeight: 100 }}
									disabled={true}
									value={note}
								></textarea>
							</div>
						</>
					)}

					{userIsAdvisor && (
						<div
							className="col-auto"
							style={{ width: "75%", margin: "auto", marginTop: 30 }}
						>
							<button
								type="button"
								className="btn btn-danger"
								onClick={() => handleConclude()}
								style={{ marginRight: "30px" }}
							>
								<ExclamationTriangleIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Ignore & Conclude</div>
							</button>

							<button
								type="button"
								className="btn btn-success"
								onClick={() => updatePayPeriodStatus(period?.id, "Open")}
							>
								<PencilSquareIcon style={{ height: "1.5em", float: "left" }} />
								<div style={{ float: "left", marginLeft: 5 }}>Amend Payroll</div>
							</button>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const { isAdmin } = state?.my?.profile || {};
	const userIsAdvisor = state?.my?.profile?.advisorId === state.company?.settings?.advisor || isAdmin;

	return {
		company: state?.company?.settings,
		period: state.payroll?.payPeriodDetails,
		userIsAdvisor,
	};
};

const mapDispatchToProps = (dispatch) => ({
	concludePayroll: (id) => dispatch(PAYROLL_ACTIONS.concludePayroll({ id })),
	updatePayPeriodStatus: (id, status) => dispatch(PAYROLL_ACTIONS.updatePayPeriodStatus(id, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollClientIssues);
